/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Box, Grid, Typography, IconButton, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import styles from '../../styles/footerStyle.js';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { FONT_FAMILY } from "../../common/sharedFunctions.js";
import { colors } from '../Theme/WebTheme';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const useStyles = makeStyles(styles);


export default function Footer(props) {
  const classes = useStyles();
  const settings = useSelector(state => state.settingsdata.settings);
  const { whiteFont } = props;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  const currentYear = new Date().getFullYear();

  const navLinks = [
    { label: t('home'), path: '/' },
    { label: t('about_us'), path: '/about-us' },
    { label: t('contact_us'), path: '/contact-us' },
    { label: t('myaccount'), path: '/bookings' }
  ];

  const legalLinks = [
    { label: t('privacy_policy'), path: '/privacy-policy' },
    { label: t('term_condition'), path: '/term-condition' }
  ];

  const socialLinks = [
    { icon: FacebookIcon, url: 'https://www.facebook.com/profile.php?id=61584622972278', label: 'Facebook' },
    { icon: InstagramIcon, url: 'https://www.instagram.com/allodriver_vtc/', label: 'Instagram' },
    { iconClass: 'fab fa-tiktok', url: 'https://www.tiktok.com/@allodriver.app', label: 'TikTok' },
    { icon: LinkedInIcon, url: 'https://linkedin.com', label: 'LinkedIn' }
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#0a0a0a',
        color: '#fff',
        pt: { xs: 6, md: 8 },
        pb: 3,
        position: 'relative',
        borderTop: `1px solid rgba(212, 175, 55, 0.2)`
      }}
    >
      <Box sx={{ maxWidth: '1200px', margin: '0 auto', px: { xs: 2, md: 4 } }}>
        {/* Main Footer Content */}
        <Grid container spacing={4} sx={{ mb: 4 }}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: FONT_FAMILY,
                fontWeight: 700,
                color: colors.Button_Primary,
                mb: 2,
                fontSize: { xs: '24px', md: '28px' }
              }}
            >
              Allô Driver
            </Typography>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                fontSize: '14px',
                color: 'rgba(255,255,255,0.7)',
                mb: 3,
                lineHeight: 1.8
              }}
            >
              Votre service de chauffeur privé à Montauban et dans toute l'Occitanie. Flotte 100% hybride et électrique pour un transport éco-responsable.
            </Typography>
            
            {/* Contact Info */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon sx={{ color: colors.Button_Primary, fontSize: 20 }} />
                <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                  Montauban, France
                </Typography>
              </Box>
              {settings?.contact_email && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <EmailIcon sx={{ color: colors.Button_Primary, fontSize: 20 }} />
                  <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                    {settings.contact_email}
                  </Typography>
                </Box>
              )}
              {settings?.contact_phone && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PhoneIcon sx={{ color: colors.Button_Primary, fontSize: 20 }} />
                  <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                    {settings.contact_phone}
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: FONT_FAMILY,
                fontWeight: 700,
                color: '#fff',
                mb: 2,
                fontSize: '18px'
              }}
            >
              Navigation
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {navLinks.map((link, index) => (
                <Typography
                  key={index}
                  onClick={() => navigate(link.path)}
                  sx={{
                    fontFamily: FONT_FAMILY,
                    fontSize: '14px',
                    color: 'rgba(255,255,255,0.7)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      color: colors.Button_Primary,
                      paddingLeft: '8px'
                    }
                  }}
                >
                  {link.label}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Legal */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: FONT_FAMILY,
                fontWeight: 700,
                color: '#fff',
                mb: 2,
                fontSize: '18px'
              }}
            >
              Informations Légales
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {legalLinks.map((link, index) => (
                <Typography
                  key={index}
                  onClick={() => navigate(link.path)}
                  sx={{
                    fontFamily: FONT_FAMILY,
                    fontSize: '14px',
                    color: 'rgba(255,255,255,0.7)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      color: colors.Button_Primary,
                      paddingLeft: '8px'
                    }
                  }}
                >
                  {link.label}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Social Media */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: FONT_FAMILY,
                fontWeight: 700,
                color: '#fff',
                mb: 2,
                fontSize: '18px'
              }}
            >
              Suivez-nous
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <IconButton
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      color: '#fff',
                      width: 40,
                      height: 40,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: colors.Button_Primary,
                        color: '#000',
                        transform: 'translateY(-3px)'
                      }
                    }}
                  >
                    {social.iconClass ? (
                      <i className={social.iconClass} style={{ fontSize: 20 }} />
                    ) : (
                      <Icon sx={{ fontSize: 20 }} />
                    )}
                  </IconButton>
                );
              })}
            </Box>
            <Typography
              sx={{
                fontFamily: FONT_FAMILY,
                fontSize: '13px',
                color: 'rgba(255,255,255,0.6)',
                lineHeight: 1.6
              }}
            >
              Rejoignez notre communauté et restez informé de nos actualités et promotions.
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)', mb: 3 }} />

        {/* SEO Keywords - Hidden for Search Engines */}
        <Box
          sx={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            whiteSpace: 'nowrap',
            border: 0
          }}
          aria-hidden="true"
        >
          <span>taxi toulouse, taxi aéroport blagnac, vtc toulouse, chauffeur privé toulouse, taxi blagnac, transport aéroport toulouse, réservation taxi toulouse, taxi occitanie, vtc aéroport blagnac, chauffeur privé blagnac, taxi gare toulouse, taxi montauban toulouse, navette aéroport blagnac, taxi toulouse blagnac, vtc toulouse blagnac, transport privé toulouse, réservation vtc toulouse, chauffeur toulouse aéroport</span>
        </Box>

        {/* Bottom Bar */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography
            sx={{
              fontFamily: FONT_FAMILY,
              fontSize: '14px',
              color: 'rgba(255,255,255,0.6)',
              textAlign: { xs: 'center', sm: 'left' }
            }}
          >
            © {currentYear} {settings?.CompanyName || 'Allô Driver'}. Tous droits réservés.
          </Typography>
          
          <Typography
            sx={{
              fontFamily: FONT_FAMILY,
              fontSize: '13px',
              color: 'rgba(255,255,255,0.5)',
              textAlign: { xs: 'center', sm: 'right' }
            }}
          >
            Développé par <a href="https://stillinov.com" target="_blank" rel="noopener noreferrer" title="Stillinov - Agence digitale innovante" style={{ color: colors.Button_Primary, textDecoration: 'none', fontWeight: 600 }}>Stillinov</a> — Solutions web & mobile
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
